export var AccessType;
(function (AccessType) {
    AccessType[AccessType["UNKNOWN"] = 0] = "UNKNOWN";
    AccessType[AccessType["READ"] = 1] = "READ";
    AccessType[AccessType["WRITE"] = 2] = "WRITE";
    AccessType[AccessType["SIGNER"] = 3] = "SIGNER";
})(AccessType || (AccessType = {}));
export function getAccess(key, type) {
    switch (type) {
        case AccessType.READ:
            return { pubkey: key, isSigner: false, isWritable: false };
        case AccessType.WRITE:
            return { pubkey: key, isSigner: false, isWritable: true };
        case AccessType.SIGNER:
            return { pubkey: key, isSigner: true, isWritable: false };
        default:
            throw new Error(`Unknown access type ${type}`);
    }
}
//# sourceMappingURL=Instructions.js.map